import EcgVisitaList from "./pages/EcgVisitaList.vue"
import EcgVisitaEdit from "./pages/EcgVisitaEdit.vue"
import EcgVisitaView from "./pages/EcgVisitaView.vue"


export default {
    EcgVisitaList,
    EcgVisitaEdit,
    EcgVisitaView,
  };